import http from '@/services/rest/rest.service';
import {
    ISaleLogsItemModel,
    IGetSaleLogsModel,
    IPaging,
    ISaleLogsModel
} from '@/entities';

export default {
    saleLogs(body: IGetSaleLogsModel): Promise<ISaleLogsModel> {
        return http.post('sale-logs', body);
    }
};
